import {Component, OnInit} from '@angular/core';
import {Message, MessageService} from 'primeng/api';
import {ScheduleService} from 'src/app/services/schedule.service';
import {UtilitiesService} from 'src/app/services/utilities.service';
import {DictionaryService} from 'src/app/services/dictionary.service';
import {IHearingDate} from '../shared/classes/hearing-date';
import {CookieService} from 'ngx-cookie-service';
import * as theGlobals from '../shared/globals';

@Component({
    selector: 'view-agenda',
    templateUrl: './view-agenda.component.html',
})

export class ViewAgendaComponent implements OnInit {
    showAgendaPacket = theGlobals.setEnv().showAgendaPacket;
    hearingDateList: IHearingDate[];
    futureHearingDateList: IHearingDate[];

    cols: any[];

    displayState: any = {
        workingDiv: false,
        gridDiv: false,
        errorMessage: false,
        iFrameWorkingDiv: false,
    };

    isAdmin = false;            // determine if user has Administrator or Clerk Of The Board role
    userRole = '';  // user role, i.e. Administrator, Assessor, Assessor-Manager, etc...

    displayIFrame = false;
    constructor(private messageService: MessageService, private schedService: ScheduleService, private dictService: DictionaryService,
                private utilService: UtilitiesService, private cookieService: CookieService) { }

    ngOnInit() {
        this.displayState.caseListDiv = false;
        this.cols = [
            { field: 'caseNum', header: 'Case #' },
            { field: 'applicantName', header: 'Applicant' },
            { field: 'status', header: 'Agenda Section' }
        ];

        let uRole = this.cookieService.get('userRole'); // get the role from login cookie
        if (uRole) {
          this.userRole = uRole;
        } else {
          uRole = this.userRole;
        }
        if (uRole.includes('Clerk') || uRole.includes('Administrator')) { this.isAdmin = true; }

        this.getHearingDates();
        if (this.utilService.isDeveloper()) {
          // this.showAgendaPacket = true; // always show the option to create agenda packet if run by developer
        }
    }

    // get list of defined Hearing Dates
    getHearingDates() {
        this.displayState.workingDiv = true;
        this.displayState.gridDiv = false;
        const tempDate = new Date();
        const tdy = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate()); // returns today with no time
        this.schedService.getHearingDates().subscribe(data => {
            // *** NOTE:    during testing, you can switch to using the hearingDateList instead of the futureHearingDateList
            //              as the source for the p-table in the template
            if (data) {
                const allDates = data;
                const pastDates = data.filter(t => {
                    const tHearDt = new Date(t.hearingDate);
                    return tHearDt > tdy ? null : t;
                });
                const futureDates = data.filter(t => {
                    const tHearDt = new Date(t.hearingDate);
                    return tHearDt >= tdy ? t : null;
                });
                // as per Anthony Luis (Assessor manager), sort agenda dates in Ascending order - 3/4/2025
                futureDates.sort((a, b) => {
                  // @ts-ignore
                  return new Date(a.hearingDate) - new Date(b.hearingDate);
                });
                this.futureHearingDateList = futureDates;
                // **** during TESTING, show ALL dates...
                // this.hearingDateList = allDates;
                this.hearingDateList = futureDates;
            }
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = true;
            this.displayState.caseListDiv = false;
        });
    }

    // triggered when user selects a Hearing Date, to display PDF
    onSelectHearing(hearing: IHearingDate, hearType: string, isFinal: boolean) {
      const hearingId = hearing.id;
      this.utilService.doAudit(hearing, 'selected hearing; hearingID: ' + hearingId);
      this.displayState.workingDiv = true;
      this.schedService.generateAgendaPdf(hearingId, hearType, isFinal).subscribe(data=> {
        this.displayState.workingDiv = false;
        this.utilService.doAudit('got response from generateAgendaPdf:');
        if (data) {
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        } else {
          this.showToast({ key: 'info', severity: 'error', detail: 'Problem generating Agenda!', summary: 'ERROR' });
          return;
        }
      });
    }
    getAgendaDocs(hearing: IHearingDate) {
      const hearingId = hearing.id;
      this.utilService.doAudit(hearing, 'getAgendaDocs; selected hearing:');
      this.displayState.workingDiv = true;
      this.utilService.getMergeDocs(hearingId).subscribe(data => {
        this.utilService.doAudit(data,'got response from getMergeDocs:');
          this.displayState.workingDiv = false;
        if (data.size > 0) {
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        } else {
            this.showToast({ key: 'info', severity: 'info', detail: 'No documents found!', summary: 'Warning' });
        }
      },
        err => {
            this.showToast({key: 'error', severity: 'error', detail: 'Problem generating agenda packet!', summary: 'Warning'});
        });
    }
    showToast(msg: Message) {
      this.messageService.add(msg);
    }
    clear() {
      this.messageService.clear();
    }

}
